import React from "react";
import GetTouchFrom from "../components/ContactComponent/GetTouchFrom";
import ContactUsForm from "../components/ContactComponent/ContactUsForm";
import { CiLocationOn } from "react-icons/ci";
import { BiPhoneCall } from "react-icons/bi";
import { MdEmail } from "react-icons/md";
import { BsClockHistory } from "react-icons/bs";
import { AiFillLinkedin } from "react-icons/ai";
import {BsTwitter} from 'react-icons/bs'
import {AiFillPhone} from 'react-icons/ai'
import {AiTwotoneMail} from 'react-icons/ai'
import {AiOutlineWhatsApp} from 'react-icons/ai'
import { IoLogoFacebook } from "react-icons/io";
import { PiSnapchatLogoFill } from "react-icons/pi";


import "./contactStyle.css";
const Contact = () => {
  const style = {
    color: "#f59e0b",
    fontSize: "2.5rem",
    marginBottom: "1.5rem",
  };

  const styleIcons={
    fontSize:"1.5rem",
    display:"inline"
  }

  return (
    <div className="contactUsMain">
      <div className="socialMediaIconsBar">
        <a href="https://www.linkedin.com/company/wet-group/" target="_blank" className="linkedin">LinkedIn 
        <AiFillLinkedin className="socialIconStyle"/>
        </a>
        <a href="https://x.com/wetgroup11" target="_blank" className="twitter">Twitter 
        <BsTwitter className="socialIconStyle"/>
        </a>
        <a href="https://www.facebook.com/wetgroup11" className="linkedin">Facebook 
        <IoLogoFacebook className="socialIconStyle"/>
        </a>
        <a href="https://snapchat.com/t/KdQguzJg" target="_blank" className="email">Snapchat 
        <PiSnapchatLogoFill className="socialIconStyle"/>
        </a>
        <a href="https://wa.me/+966599974174" target="_blank" className="whatsapp">WhatsApp 
        <AiOutlineWhatsApp className="socialIconStyle"/>
        </a>
      </div>
      <div className="pageHeader ">
        <h1>
          Contact Us <hr className="customUnderlineHeader" />{" "}
        </h1>
      </div>
      <div className="sectionTwo">
        <h1 className="sectionHeadingTwo">
          Get in touch <hr className="customUnderline" />
        </h1>

        <div className="contact-details">
          <div className="contact">
            <CiLocationOn className="contactIcon" />
            <p>
            Yaha Alshaier St.
            Building No. 7507
            AlRawadah Dist .
              <br /> Riyadh ,KSA 13211
            </p>
          </div>
          <div className="contact">
            <BiPhoneCall className="contactIcon" />
            <p >+966 59 997 4174</p>
            
          </div>
          <div className="contact">
            <MdEmail className="contactIcon" />
            <p>info@wetgroup.net</p>
          </div>
          <div className="contact">
            <BsClockHistory className="contactIcon" />
            <p>
              Sunday to Thursday <br /> (08:00AM - 5:00PM)
            </p>
          </div>
        </div>
      </div>
      {/* <ContactUsForm/> */}

      <GetTouchFrom />
    </div>
  );
};

export default Contact;
